// extracted by mini-css-extract-plugin
export default {"gearCell":"TableHeader_gearCell__8V9ZX","gear":"TableHeader_gear__BT0ZA","placeHolderShimmer":"TableHeader_placeHolderShimmer__7C63N"};